import React, { useState } from 'react';
import './index.less';
import { Popover } from 'antd';
import apis from '../../../apis';
// import { enhancedFormateTimeStamp } from '@/common/utils/format-time'
// {enhancedFormateTimeStamp(data.created, 'YY-MM-DD hh:mm')}
const ChangeHover = (props) => {
  const [content, setContent] = useState({
    id: undefined,
    resourceName: undefined,
    channelName: undefined,
    created: undefined,
  });
  const hoverContent = (
    <div className="resource-manage-changgehover">
      <div className="resource-manage-changehover-layout">
        <div className="changgehover-title">资源申请编号：</div>
        <div>{content.id}</div>
      </div>
      <div className="resource-manage-changehover-layout">
        <div className="changgehover-title">资源位名称：</div>
        <div>{content.resourceName}</div>
      </div>
      <div className="resource-manage-changehover-layout">
        <div className="changgehover-title">频道名称：</div>
        <div>{content.channelName}</div>
      </div>
      <div className="resource-manage-changehover-layout">
        <div className="changgehover-title">申请时间：</div>
        <div>{content.created}</div>
      </div>
    </div>
  );

  const getList = (appId) => {
    apis
      .applyReadServicequeryForList({ applyId: appId, page: 1, pageSize: 1 })
      .then((res) => {
        const {
          ret,
          data: { items },
        } = res;
        if (ret === '0') {
          const item = items[0];
          const created = item.created;
          const resourceName = item.homeFloorInfo ? item.homeFloorInfo.resourceName : '';
          const channelName = item.homeFloorInfo ? item.homeFloorInfo.channelName : '';
          setContent({
            id: item.id,
            resourceName: resourceName,
            channelName: channelName,
            created: created,
          });
        }
      })
      .catch((ex) => {});
  };
  return (
    <div>
      {props.originalApplyId ? (
        <Popover placement="bottomLeft" content={hoverContent} trigger="hover">
          <div
            className="resource-manage-change"
            onMouseEnter={() => {
              getList(props.originalApplyId);
            }}
          >
            改
          </div>
        </Popover>
      ) : null}
    </div>
  );
};

export default ChangeHover;
